import styled from 'styled-components';

export const LiteTradeChartWrapperStyled = styled.div`

`;

export const LiteTradeChartWrapperTimeframesStyled = styled.div`
    overflow: auto;
    position: relative;

    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */

    &::-webkit-scrollbar {
        display: none;
    }

    &:before,
    &:after {
        position: fixed;
        top: 0;
        bottom: 0;
        content: '';
        display: block;
        width: 0;
        box-shadow: 0 0 16px 8px var(--color-base);
    }

    &:before {
        left: 0;
    }

    &:after {
        right: 0;
    }

    .btn-info {
        white-space: nowrap;
        border-radius: 4px;
        box-shadow: none;
        min-width: 68px;
        
        &:hover {
            background: #393C5D;
            border: 1px solid #393C5D;
        }

        &:first-child {
            margin-left: 16px;
        }

        &:last-child {
            margin-right: 16px;
        }
    }
`;
